
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Tab } from 'bootstrap';
  import { useI18n } from 'vue-i18n';
  import AOS from 'aos';
  import * as _ from 'lodash';

  import FormInput from '@/views/programs/components/FormInput.vue';
  import FormFileInput from '@/views/programs/components/FormFileInput.vue';
  import FormDateInput from '@/views/programs/components/FormDateInput.vue';
  import FormCheckboxInput from '@/views/programs/components/FormCheckboxInput.vue';
  import RecursiveSelect from '@/views/programs/components/RecursiveSelect.vue';
  import FormBuilder from '@/views/programs/components/FormBuilder.vue';

  export default defineComponent({
    name: 'apply',
    components: {
      Tab,

      Field,
      Form,
      ErrorMessage,

      FormBuilder,
      RecursiveSelect,
      FormCheckboxInput,
      FormDateInput,
      FormFileInput,
      FormInput,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const i18n = useI18n();
      const { t } = useI18n();

      const user = computed(() => {
        return store.getters['moduleAuth/getAuthUser'];
      });

      let emptyArray: any = [];
      let currentSelected: any = null;
      const state = reactive({
        loading: false,
        started: false,
        currentStep: null,
        selectedSubmission: currentSelected,

        ProgramData: null,
        steps: emptyArray,
      });

      onMounted(() => {
        AOS.init();
        getProgram();
      });

      const getProgram = () => {
        state.loading = true;
        let id: any = route?.params?.id;
        store.dispatch('modulePrograms/findProgramDetails', { id: id })
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            state.ProgramData = data.data;
            state.steps = response.dynamicFormsJsonWithOrder;
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      };

      const goToPrograms = () => {
        router.push({ name: 'all_programs_page' });
      };

      const goToEditProgram = (id) => {
        router.push({ name: 'apply_program_page', params: { id: id } });
      };

      const isSubmitted = (id) => {
        let ProgramData: any = state.ProgramData;
        let flag = false;
        if(!ProgramData.formJsonSubmission){
          return false;
        }
        _.forEach(ProgramData.formJsonSubmission.formSubmissions, (form) => {
          if (form.formJsonId._id == id) {
            flag = true;
          }
        });
        return flag;
      };

      const showModalPrograms = (id) => {
        let ProgramData: any = state.ProgramData;
        state.selectedSubmission = null;
        if(!ProgramData.formJsonSubmission){
          return false;
        }
        _.forEach(ProgramData.formJsonSubmission.formSubmissions, (form: any) => {
          if (form.formJsonId._id == id) {
            let formJson: any = form.formJsonId.formJson;
            let formJsonWithData: any = generateJsonFormWithData(formJson.items, form.formData[formJson.model_key]);
            form.formJsonWithData = formJsonWithData;
            setTimeout(() => {
              state.selectedSubmission = form;
            }, 500);
          }
        });
      };


      // generate form json with data
      const generateJsonFormWithData = (items, formData) => {
        return generateJsonFormItems(items, formData);
      };

      const generateSection = (items, section, sectionData, index) => {
        let value = JSON.parse(JSON.stringify(section));
        value.section_repeat_index = index;
        value.key = Math.random().toString(16);
        sectionData = refineFormData(sectionData);
        value.items = generateJsonFormItems(value.items, sectionData);
        return value;
      };

      const generateJsonFormItems = (items, formData) => {
        // console.log(items);
        formData = refineFormData(formData);
        for (let i = 0; i < items.length; i++) {
          if (items[i].type == 'Section') {
            if (formData[items[i].model_key] != null) {
              if (!Array.isArray(formData[items[i].model_key])) { // is map
                formData[items[i].model_key] = refineFormData(formData[items[i].model_key]);
                generateJsonFormItems(items[i].items, formData[items[i].model_key]);
              } else if (Array.isArray(formData[items[i].model_key])) { // is list
                for (let j = 0; j < formData[items[i].model_key].length; j++) {
                  let generatedSection = generateSection(items,
                    items[i],
                    formData[items[i].model_key][j],
                    j + 1,
                  );
                  if (j == 0) {
                    items[i] = generatedSection;
                  } else {
                    items.splice(j + i, 0, generatedSection);
                  }
                }
                i = parseInt(i + formData[items[i].model_key].length) - 1;
              }
            }
          } else if (items[i].type == 'Check') {

            items[i].key = Math.random().toString(16);
            items[i].values = formData[items[i].model_key] == null
              ? []
              : (typeof formData[items[i].model_key] === 'object') //     is array
                ? formData[items[i].model_key]
                : (typeof formData[items[i].model_key] === 'string') // is string
                  ? [formData[items[i].model_key]]
                  : (typeof formData[items[i].model_key] === 'number') // is number
                    ? [formData[items[i].model_key]]
                    : [];

          } else if (items[i].type == 'Radio' || items[i].type == 'DropDownList') {
            items[i].value = formData[items[i].model_key];
            items[i].key = Math.random().toString(16);
            let selectionValue = getSelectionValueByID(
              items[i].selection_values, (formData[items[i].model_key]),
            );
            if (selectionValue != null) {
              if (selectionValue.section != null) {
                if (!checkIfSectionAdded(items, selectionValue.section.model_key)) {
                  items.splice(i + 1, 0, selectionValue.section);
                }
              }
            }
          } else {
            items[i].value = formData[items[i].model_key];
            items[i].key = Math.random().toString(16);
          }
        }
        return items;
      };

      const refineFormData = (formData) => {
        const formKeys = Object.keys(formData);
        for (let i = 0; i < formKeys.length; i++) {
          if (Array.isArray(formData[formKeys[i]])) {
            refineFormDataList(formData[formKeys[i]]);
          } else if (typeof formData[formKeys[i]] === 'object' && formData[formKeys[i]] !== null) {
            formData[formKeys[i]] = refineFormData(formData[formKeys[i]]);
          }
        }
        return formData;
      };

      const refineFormDataList = (formDataList) => {
        for (let i = formDataList.length - 1; i >= 0; i--) {
          if (formDataList[i] === null) {
            formDataList.splice(i, 1);
          }
        }
      };

      const insertAfterIndex = (arr, index, newItem) => [
        ...arr.slice(0, index),
        newItem,
        ...arr.slice(index),
      ];

      const checkIfSectionAdded = (items, modelKey) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].model_key == modelKey) {
            return true;
          }
        }
        return false;
      };

      const getSelectionValueByID = (selectionValues, id) => {
        let selectionValue: any = null;
        for (let i = 0; i < selectionValues.length; i++) {
          if (selectionValues[i].id == id) {
            selectionValue = selectionValues[i];
            break;
          }
        }
        return selectionValue;
      };
      // end generate form json with data


      return {
        ...toRefs(state),
        isSubmitted,
        showModalPrograms,
        goToPrograms,
        goToEditProgram,
        i18n,
        user,
      };
    },
  });
